import { ListItemButton, ListItemText, useTheme } from "@mui/material";
import type { FC } from "react";
import { ExpenseCategoryTitleLine } from "web_myplann/Finances/Components/ExpenseCategoryTitleLine";
import type { ClientFinancialPlanExpenseTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	type: ClientFinancialPlanExpenseTypeEnum;
	total: number;
	expanded: boolean;
	onToggle: () => void;
};

export const ExpenseCategoryHeader: FC<Props> = ({
	type,
	total,
	expanded,
	onToggle,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const R = Resources.Finances.Expenses.Types[type];

	return (
		<ListItemButton
			disableRipple
			onClick={onToggle}
			aria-expanded={expanded}
			sx={{
				px: theme.spacingTokens.lg,
				py: theme.spacingTokens.md,
				"&:active": { bgcolor: theme.palette.grey[50] },
			}}
		>
			<ListItemText
				sx={{ my: 0 }}
				primary={
					<ExpenseCategoryTitleLine
						title={t(R.title)}
						total={total}
						expanded={expanded}
					/>
				}
				secondary={t(R.description)}
				slotProps={{
					primary: { component: "div" },
					secondary: {
						variant: "hint",
						color: theme.palette.grey[400],
						display: "block",
						mt: theme.spacingTokens.xxs,
						noWrap: !expanded,
					},
				}}
			/>
		</ListItemButton>
	);
};
